import { Link } from "react-router-dom";
import { Globe2, Mail, Phone, ArrowRight } from "lucide-react";
import { Logo } from "./Logo";
import { PHONE_TEL, PHONE_DISPLAY, EMAIL, BRAND, COMPANY, FOOTER_AIRLINES, DESTINATIONS, MORE_WAYS } from "@/lib/site";

const HELP = [
  { to: "/about", label: `About ${BRAND}` }, { to: "/contact", label: "Contact our team" },
  { to: "/help", label: "Help center" }, { to: "/blog", label: "Travel journal" }, { to: "/site-map", label: "Site map" },
];

const Col = ({ title, children }) => (
  <div>
    <h3 className="font-display text-sm font-bold text-white">{title}</h3>
    <ul className="mt-5 space-y-3 text-[13px] text-white/75">{children}</ul>
  </div>
);
const L = ({ to, children }) => <li><Link to={to} data-testid={`footer-link-${to.replace(/\//g, "-")}`} className="transition-colors hover:text-coral">{children}</Link></li>;

export const SiteFooter = () => (
  <footer className="bg-ink pb-28 text-white sm:pb-24" data-testid="site-footer">
    <div className="mx-auto max-w-[1320px] px-4 sm:px-8">
      <div className="flex flex-col justify-between gap-3 border-b border-white/10 py-6 text-sm sm:flex-row sm:items-center">
        <p className="flex items-center gap-3 text-white/85"><Globe2 className="h-4 w-4" /> Near or far, your next journey starts here.</p>
        <a href={PHONE_TEL} data-testid="footer-lets-talk" className="group flex items-center gap-2 font-bold text-coral">Let’s talk travel <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" /></a>
      </div>
      <div className="grid gap-10 py-12 sm:grid-cols-2 lg:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo light testId="footer-logo" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-white/80">Domestic and international flight booking assistance for U.S. travelers. Compare airline options with an independent travel specialist.</p>
          <a href={PHONE_TEL} data-testid="footer-phone" className="mt-5 flex items-center gap-3 text-sm hover:text-coral"><Phone className="h-4 w-4" />{PHONE_DISPLAY}</a>
          <a href={`mailto:${EMAIL}`} data-testid="footer-email" className="mt-3 flex min-w-0 items-center gap-2 text-sm hover:text-coral"><Mail className="h-4 w-4 shrink-0" /><span className="break-all">{EMAIL}</span></a>
          <p className="mt-5 max-w-xs text-xs text-white/60">{BRAND} is operated by {COMPANY}</p>
        </div>
        <Col title="Explore airlines">{FOOTER_AIRLINES.map((a) => <L key={a.code} to={`/airlines/${a.slug}`}>{a.name.replace(" Airlines", "")}</L>)}</Col>
        <Col title="Around the world">{DESTINATIONS.map((d) => <L key={d.slug} to={`/flights-to/${d.slug}`}>{d.name}</L>)}</Col>
        <Col title="Here to help">
          {HELP.map((h) => <L key={h.to} to={h.to}>{h.label}</L>)}
          <li className="pt-3 text-xs"><Link to="/privacy" data-testid="footer-privacy" className="hover:text-coral">Privacy policy</Link></li>
          <li className="text-xs"><Link to="/terms" data-testid="footer-terms" className="hover:text-coral">Terms & conditions</Link></li>
        </Col>
      </div>
      <div className="border-t border-white/10 py-6">
        <p className="font-display text-sm font-bold">More ways to travel</p>
        <div className="mt-4 flex flex-wrap gap-x-7 gap-y-3 text-xs text-white/75">
          {MORE_WAYS.map((m) => <Link key={m.to} to={m.to} data-testid={`footer-more-${m.to.slice(1)}`} className="group flex items-center gap-1.5 hover:text-coral">{m.label}<ArrowRight className="h-3 w-3 transition-transform group-hover:translate-x-0.5" /></Link>)}
        </div>
      </div>
      <div className="flex flex-col justify-between gap-2 border-t border-white/10 pt-6 text-xs text-white/60 sm:flex-row">
        <p>© 2026 {BRAND}.</p>
        <p>Independent travel agency. Airline names and logos are for reference only and belong to their respective owners.</p>
      </div>
    </div>
  </footer>
);
